import React, { useState } from 'react';
import { XMarkIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const tourSteps = [
  {
    title: "2026 AI Governance & Regulatory Command Center",
    content: "Enterprise AI safety powered by Jev Cognitive Architecture (System 1 Deterministic Edge Arbiter + System 2 Regulatory Governance) enforcing the EU AI Act (2024/1689), Colorado SB 24-205, and NIST SP 1270-1.",
    target: null
  },
  {
    title: "Statutory Matrix & Composite Compliance",
    content: "Live multi-framework evaluation tracking EU Article 5 Prohibitions, Article 27 FRIAs, Colorado algorithmic discrimination audits, and Jev Reflex sub-millisecond edge guardrail rates.",
    target: "compliance-gauge"
  },
  {
    title: "Cryptographic Model Registry & Arbiter Seals",
    content: "Inspect registered models with verified HMAC-SHA256 Arbiter hashes, GPAI frontier systemic risk (>10²⁵ FLOPs) designations, and DPO statutory approvals.",
    target: "model-registry"
  },
  {
    title: "Role-Based Governance Workflows",
    content: "Tailored statutory actions: Developers manage compute and edge guardrails; DPOs conduct Article 27 Fundamental Rights Impact Assessments; Executives export audit ledgers.",
    target: "role-actions"
  },
  {
    title: "Live Onboarding & Regulatory Pre-Flight",
    content: "Engineers declare foundation architecture, compute FLOPs, and oversight mechanisms. The system instantly detects EU Article 5 prohibited practices and flags mandatory pre-deployment filings.",
    target: "onboard-form"
  }
];

function DemoTour({ isOpen, onClose }) {
  const [currentStep, setCurrentStep] = useState(0);

  if (!isOpen) return null;

  const nextStep = () => {
    if (currentStep < tourSteps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onClose();
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const currentTourStep = tourSteps[currentStep];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-900">
            Demo Tour ({currentStep + 1}/{tourSteps.length})
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="mb-6">
          <h4 className="text-md font-medium text-gray-900 mb-2">
            {currentTourStep.title}
          </h4>
          <p className="text-sm text-gray-600">
            {currentTourStep.content}
          </p>
        </div>

        <div className="flex justify-between items-center">
          <button
            onClick={prevStep}
            disabled={currentStep === 0}
            className="flex items-center px-3 py-2 text-sm text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <ChevronLeftIcon className="h-4 w-4 mr-1" />
            Previous
          </button>

          <div className="flex space-x-1">
            {tourSteps.map((_, index) => (
              <div
                key={index}
                className={`h-2 w-2 rounded-full ${
                  index === currentStep ? 'bg-blue-600' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>

          <button
            onClick={nextStep}
            className="flex items-center px-3 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            {currentStep === tourSteps.length - 1 ? 'Finish' : 'Next'}
            {currentStep < tourSteps.length - 1 && (
              <ChevronRightIcon className="h-4 w-4 ml-1" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DemoTour;